import React from 'react';
import { Outlet } from "react-router";

const BehaviorLayout: React.FC = () => {
    return (
        <div className="behavior-container">
            <Outlet /> 
        </div>
    );
};

export default BehaviorLayout;